import { render } from "./VanillaB.vue?vue&type=template&id=607e8f2a&scoped=true"
import script from "./VanillaB.vue?vue&type=script&lang=js"
export * from "./VanillaB.vue?vue&type=script&lang=js"

import "./VanillaB.vue?vue&type=style&index=0&id=607e8f2a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-607e8f2a"]])

export default __exports__